import { render, staticRenderFns } from "./OldHistoryNorthList.vue?vue&type=template&id=124e91b3"
import script from "./OldHistoryNorthList.vue?vue&type=script&lang=js"
export * from "./OldHistoryNorthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports